import { omniAtom } from "src/utils/atoms";

export const duplicateMerchflowModalAtom = omniAtom({
  key: "modals/duplicateMerchflow",
  value: null as null | {
    id: number;
    name: string;
    onSuccess?: () => void;
  },
});
